<template>
  <div class="board_write_wrap">
    <div class="board_view">
      <div class="view_title">
        <div type="text" v-bind:value="boardLists.title" class="title">{{ boardLists.title }}</div>
        <div class="info1">
          <div style="float: left; width: 150px">
            <span class="view_writer">작성자 </span>
            <p type="text" v-bind:value="boardLists.writer" class="writer">관리자</p>
          </div>
          <div style="float: left; width: 180px">
            <span class="view_date">| 작성일 </span>
            <p type="text" v-bind:value="boardLists.date" class="date">{{ boardLists.date }}</p>
          </div>
          <div style="float: left; width: 100px">
            <span class="view_count">| 조회수 </span>
            <p type="text" v-bind:value="boardLists.count" class="count">{{ boardLists.count }}</p>
          </div>
        </div>
      </div>

      <div class="view_content">
        <p type="text" v-bind:value="boardLists.contents" class="contents" readonly>{{ boardLists.contents }}</p>
      </div>

      <div class="board_btn">
        <router-link :to="{ name: 'noticeList' }" class="bnt_cancel">확인</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: {},

  data() {
    return {
      boardLists: {},
    }
  },
  created() {
    axios
      .get('/api/notice/getOne/' + this.$route.query.id)
      .then((res) => {
        this.boardLists = res.data[0]
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {},
}
</script>

<style>
@import '../../../style/boardView.css';
</style>
